import { render, staticRenderFns } from "./MsdsItem.vue?vue&type=template&id=ea0543ea&scoped=true&"
import script from "./MsdsItem.vue?vue&type=script&lang=js&"
export * from "./MsdsItem.vue?vue&type=script&lang=js&"
import style0 from "./MsdsItem.vue?vue&type=style&index=0&id=ea0543ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0543ea",
  null
  
)

export default component.exports